import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewVerifications = async (data) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/common?table=verification`,
      data
    );
    return res.data;
  } catch (error) {
    console.error(error, "error");
  }
};
export const checkVerificationsById = async (data) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/verification?id=${data?.id}&type=${data?.type}&start_date=${data.start_date}&end_date=${data.end_date}`
    );
    return res.data;
  } catch (error) {
    console.error(error, "error");
  }
};
export const updateVerificationsById = async (id, data) => {
  try {
    const res = await axios.patch(
      `${API_BASE_URL}/common?table=verification&id=${id}`,
      data
    );
    return res.data;
  } catch (error) {
    console.error(error, "error");
  }
};
